export const REPORT_SETTINGS_PERIODS = [
    { _id: 'YESTERDAY', name: 'str.report.settings.period.yesterday' },
    { _id: 'TODAY', name: 'str.report.settings.period.today' },
    { _id: 'WEEKLY', name: 'str.report.settings.period.weekly' },
    { _id: 'MONTHLY', name: 'str.report.settings.period.monthly' },
]
